export default {
    activities_main_id: 'Id',
    activities_main_username: 'Usuario',
    activities_main_controller: 'Controlador',
    activities_main_action: 'Acción',
    activities_main_date_time: 'Fecha y hora',
    activities_main_source: 'Fuente',
    activities_main_url: 'Url',
    activities_main_method: 'Método',
    activities_main_ip_address: 'Dirección IP',
    activities_main_platforms: 'Plataformas',
    activities_main_entity_name: 'Nombre de la entidad',
    activities_main_entity_id: 'Id. de la entidad',
    activities_main_parameters: 'Parámetros',
    activities_main_new_values: 'Nuevos valores',
    activities_main_error_message: 'Es necesario seleccionar una cuenta',
    activities_main_apply_filters: 'Aplicar filtros',
    activities_main_user_activity_logs: 'Registros de Actividad de los Usuarios',
    activities_main_account: 'Cuenta',
    activities_main_actions: 'Acciones',
    activities_main_time_frame: 'Tiempo',
    activities_main_apply: 'Aplicar',
    activities_main_search_controller: 'Buscar por controlador',
};
